import 'utils/googleTranslateFix';

try {
	// eslint-disable-next-line no-undef
	__webpack_public_path__ = window.__BASE_URL__;
} catch (e) {}

import { h, render } from 'preact';

import UniversalCMSPreviewApp from 'base/universalCMSPreview/universalCMSPreviewApp';

let elem = document.getElementById('app');
if (!elem) {
	elem = document.createElement('div');
	elem.id = 'app';
	document.body.append(elem);
}
render(<UniversalCMSPreviewApp initialStore={window.__INITIAL_STATE__} />, elem, elem.firstChild);
